import React, { useState, useEffect } from "react";
import comingSoonGif from "../assets/images/comming_soon_500x500.gif";
// import comingSoonGif from "../assets/images/loading-500x500.gif";
// ^ Save the downloaded file as:  src/assets/images/coming-soon.gif
//   Adjust the relative path above to match where THIS component lives
//   (e.g. from src/components/ it's "../assets/images/coming-soon.gif"),
//   or use an alias like "@/assets/images/coming-soon.gif" if you have one.

export function ComingSoonLink({
  children,
  title = "",
  message = "This file format is being finalised and will be available here shortly. Please check back soon.",
}) {
  const [open, setOpen] = useState(false);

  // Close on Esc + lock background scroll while open
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open]);

  return (
    <>
      <a href="#" style={styles.link} onClick={(e) => { e.preventDefault(); setOpen(true); }}>
        {children}
      </a>

      {open && (
        <div style={styles.overlay} onClick={() => setOpen(false)}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <button style={styles.close} onClick={() => setOpen(false)} aria-label="Close">
              &times;
            </button>
            <img src={comingSoonGif} alt="Coming soon" style={styles.gif} />
            <h2 style={styles.title}>{title}</h2>
            <p style={styles.text}>{message}</p>
          </div>
        </div>
      )}
    </>
  );
}

const styles = {
  link: { color: "#634B83", cursor: "pointer"},
  overlay: {
    position: "fixed", inset: 0, zIndex: 9999, padding: "16px",
    background: "rgba(34, 24, 48, 0.55)",
    display: "flex", alignItems: "center", justifyContent: "center",
  },
  modal: {
    position: "relative", width: "100%", maxWidth: "400px",
    background: "#fff", borderRadius: "16px", padding: "36px 28px 30px",
    textAlign: "center", boxShadow: "0 20px 50px rgba(49, 33, 71, 0.25)",
  },
  close: {
    position: "absolute", top: "12px", right: "12px",
    width: "32px", height: "32px", border: "none", borderRadius: "50%",
    background: "#F3EFF8", color: "#634B83",
    fontSize: "20px", lineHeight: 1, cursor: "pointer",
  },
  gif: { width: "200px", height: "auto", display: "block", margin: "0 auto 8px" },
  title: { margin: "10px 0 8px", fontSize: "22px", fontWeight: 700, color: "#2E2143" },
  text: { margin: "0 auto", maxWidth: "280px", fontSize: "18px", lineHeight: 1.55, color: "#6B6478" },
};

export default ComingSoonLink;